var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWave(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1920 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1920 0H0v106.346s248.608 52.982 519.797 52.982c124.565 0 248.381-22.012 382.267-45.814C1059.66 85.497 1231.2 55 1434.35 55c375.73 0 485.65 51.346 485.65 51.346V0z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWave);
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTkyMCAxNjAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPHBhdGggZD0iTTE5MjAgMEgwdjEwNi4zNDZzMjQ4LjYwOCA1Mi45ODIgNTE5Ljc5NyA1Mi45ODJjMTI0LjU2NSAwIDI0OC4zODEtMjIuMDEyIDM4Mi4yNjctNDUuODE0QzEwNTkuNjYgODUuNDk3NCAxMjMxLjIgNTUgMTQzNC4zNSA1NWMzNzUuNzMgMCA0ODUuNjUgNTEuMzQ2IDQ4NS42NSA1MS4zNDZWMFoiIGZpbGw9IiNmZmYiLz4KPC9zdmc+";
export { ForwardRef as ReactComponent };